<template>
  <div>
    <h5 class="mb-3">Crear devolución</h5>

    <div class="mb-3">
      <label class="form-label text-xs">Pedido ID</label>
      <input class="form-control" :value="pedidoId" disabled />
    </div>

    <div class="mb-3" v-if="pedidoTotalNumero !== null">
      <label class="form-label text-xs">Total del pedido</label>
      <input class="form-control" :value="pedidoTotalNumero.toFixed(2) + ' EUR'" disabled />
    </div>

    <div class="mb-3">
      <label class="form-label text-xs">Importe (opcional)</label>
      <input
        v-model="amount"
        type="number"
        step="0.01"
        min="0.50"
        :max="pedidoTotalNumero ?? undefined"
        inputmode="decimal"
        class="form-control"
        placeholder="Vacío = total del pedido"
      />
      <div class="text-xs opacity-7 mt-1">
        Si lo dejas vacío, el backend devuelve el total del pedido.
      </div>
      <div v-if="pedidoTotalNumero !== null" class="text-xs opacity-7 mt-1">
        Máximo permitido: {{ pedidoTotalNumero.toFixed(2) }} EUR
      </div>
    </div>

      <div class="mb-3">
        <label class="form-label text-xs">Motivo (opcional)</label>
        <select v-model="reason" class="form-control">
          <option value="">(sin motivo)</option>
          <option value="requested_by_customer">Solicitado por el cliente</option>
          <option value="duplicate">Pago duplicado</option>
          <option value="fraudulent">Fraudulento</option>
        </select>
      </div>

    <div class="mb-3">
      <label class="form-label text-xs">Nota interna (opcional)</label>
      <textarea v-model="nota" class="form-control" rows="3" placeholder="Nota para auditoría..."></textarea>
    </div>

    <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

    <div class="d-flex justify-content-end gap-2">
      <button class="btn btn-sm btn-outline-secondary" @click="$emit('cerrar-modal')">Cancelar</button>
      <button class="btn btn-sm btn-primary" :disabled="cargando" @click="enviar">
        {{ cargando ? 'Procesando...' : 'Crear devolución' }}
      </button>
    </div>
  </div>
</template>

<script>
import { crearDevolucion } from "@/services/devoluciones";

export default {
  name: "CrearDevolucionForm",
  props: {
    pedidoId: { type: [String, Number], required: true },
    pedidoTotal: { type: [String, Number], default: null },
  },
  data() {
    return {
      cargando: false,
      error: "",
      amount: "",
      reason: "",
      nota: "",
    };
  },
  computed: {
    pedidoTotalNumero() {
      if (this.pedidoTotal === null || this.pedidoTotal === undefined || this.pedidoTotal === "") {
        return null;
      }
      const n = Number(this.pedidoTotal);
      return Number.isFinite(n) ? n : null;
    },
  },
  methods: {
    async enviar() {
      this.cargando = true;
      this.error = "";
      try {
        const payload = {
          pedido_id: Number(this.pedidoId),
          reason: this.reason || undefined,
          nota: this.nota || undefined,
        };

        // amount opcional
        if (String(this.amount).trim() !== "") {
          const amountNum = Number(this.amount);

          if (!Number.isFinite(amountNum)) {
            this.error = "El importe debe ser un número válido.";
            this.cargando = false;
            return;
          }

          if (amountNum < 0.5) {
            this.error = "El importe mínimo para devolver es 0.50.";
            this.cargando = false;
            return;
          }

          if (this.pedidoTotalNumero !== null && amountNum > this.pedidoTotalNumero) {
            this.error = `El importe no puede superar el total del pedido (${this.pedidoTotalNumero.toFixed(2)} EUR).`;
            this.cargando = false;
            return;
          }

          payload.amount = amountNum;
        }

        await crearDevolucion(payload);

        // notifica OK al padre para refrescar
        this.$emit("ok");
        this.$emit("cerrar-modal");
      } catch (e) {
        this.error = e?.response?.data?.mensaje || "Error creando devolución";
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>
<style scoped>
  select.form-control {
    background-image: none !important;
    -webkit-appearance: menulist !important;
    -moz-appearance: menulist !important;
    appearance: menulist !important;
    padding-right: 0.75rem !important;
  }
</style>